import { ReactNode } from "react";
import { cn } from "../../lib/utils";
import CustomIcon from "../CustomIcon";

export default function SettingButton({
  children,
  className,
  iconName,
  iconScale,
  icon,
  onClick,
  inputChild,
  rightIcon,
}: {
  children?: ReactNode;
  className?: string;
  iconName?: string;
  iconScale?: number;
  icon?: ReactNode;
  onClick?: () => void;
  inputChild?: ReactNode;
  rightIcon?: ReactNode;
}) {
  return (
    <div
      className={cn(
        "flex items-center justify-between bg-secondary-bluegrey-1 p-[12px_32px] box-border w-full",
        "[&_svg]:min-w-5 [&_svg]:max-w-5 [&_svg]:min-h-5 [&_svg]:max-h-5",
        "[&_svg_path]:min-w-5 [&_svg_path]:max-w-5 [&_svg_path]:min-h-5 [&_svg_path]:max-h-5",
        "[&_svg_circle]:min-w-5 [&_svg_circle]:max-w-5 [&_svg_circle]:min-h-5 [&_svg_circle]:max-h-5",
        "[&_span]:font-dm-sans [&_span]:text-base [&_span]:font-normal [&_span]:leading-[21px] [&_span]:text-start [&_span]:text-primary-black",
        "[&.lemon-certified-button]:bg-secondary-soft-yellow-2",
        "[&.lemon-certified-button>svg]:animate-[spin_3s_linear_infinite]",
        className
      )}
      onClick={() => onClick && onClick()}
    >
      <div className="flex items-center gap-4">
        {iconName ? (
          <CustomIcon
            color="#000000"
            iconName={iconName}
            scale={iconScale ?? 1}
          />
        ) : icon ? (
          icon
        ) : null}
        <span>{children}</span>
      </div>
      {rightIcon || inputChild}
    </div>
  );
}
